import React from 'react'

const ResponseMsg = ({ message }) => {
    return (
        <>
            <div className='response-area animate__animated animate__fadeInDown'>
                {message}
            </div>
        </>
    )
}

export default ResponseMsg
